var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.32,396.8V102.4c0-7.069-5.731-12.8-12.8-12.8H55.536c-7.069,0-12.8,5.731-12.8,12.8l0,0v294.4H469.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 396.804,
    style: {
      fill: "#E21B1B"
    },
    width: 512.001,
    height: 8.536
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E21B1B"
    },
    points: "486.4,422.401 25.6,422.401 0,405.328 512,405.328  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.04,396.8h-86.08c0.75,4.866,4.908,8.477,9.832,8.536h66.4 C294.12,405.28,298.286,401.671,299.04,396.8z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.552,
    y: 106.43,
    style: {
      fill: "#CCCCCC"
    },
    width: 392.887,
    height: 290.364
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2A9AA"
    },
    cx: 255.665,
    cy: 98.052,
    r: 2.916
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "42.736,262.776 42.736,89.6 248.496,89.6  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopSvgrepoCom);
export default __webpack_public_path__ + "static/media/laptop-svgrepo-com.e7ef5de7fdfb2e860378c519a12e340a.svg";
export { ForwardRef as ReactComponent };